import React from 'react';

function Pagination(props) {

    let paginationTag = [];

    if (props.pagination === undefined) {
        paginationTag = "-";
    } else {
        
        const currentPageNo = props.pagination.currentPageNo;
        const pageSize = props.pagination.pageSize;
        const totalRecordCount = props.pagination.totalRecordCount;
        const recordCountPerPage = props.pagination.recordCountPerPage;

        const totalPageCount = Math.ceil(totalRecordCount / recordCountPerPage);
        const currentFirstPage = Math.floor((currentPageNo - 1) / pageSize) * pageSize + 1;
        let currentLastPage = currentFirstPage + pageSize - 1;
        currentLastPage = (currentLastPage > totalPageCount) ? totalPageCount : currentLastPage;

        if (totalPageCount > pageSize) {
            // 이전 페이지 이동
            const prevPageIndex = (currentPageNo - 1 > 0) ? currentPageNo - 1 : 1;
            const previousPageTag =
                <span key="pp" className="pageButton" onClick={e => {props.moveToPage(prevPageIndex)}}>
                    <a onClick={e => {props.moveToPage(prevPageIndex)}}>&lt; 이전</a>
                </span>;
            paginationTag.push(previousPageTag);
        }

        for (let i = currentFirstPage; i <= currentLastPage; i++) {
            if (i === currentPageNo) {
                // 현재 페이지
                const currentPage =
                    <span key={i} className="pageButton active">
                        <a>{i}</a>
                    </span>;
                paginationTag.push(currentPage);
            } else {
                // 다른 페이지
                const otherPage =
                    <span key={i} className="pageButton" onClick={e => {props.moveToPage(i)}}>
                        <a onClick={e => {props.moveToPage(i)}}>{i}</a>
                    </span>;
                paginationTag.push(otherPage);
            }
        }
        if (totalPageCount > pageSize) {
            // 다음 페이지 이동
            const nextPageIndex = (currentLastPage + 1 < totalPageCount) ? currentLastPage + 1 : totalPageCount;
            const nextPageTag =
                <span key="np" className="pageButton" onClick={e => {props.moveToPage(nextPageIndex)}}>
                    <a onClick={e => {props.moveToPage(nextPageIndex)}}>다음 &gt;</a>
                </span>;
            paginationTag.push(nextPageTag);
        }
    }

    return (
        <div className="pagination">
            <ul>
                {paginationTag}
            </ul>
        </div>
    );
}

export default React.memo(Pagination);